<template>
  <header class="vedio-content">
    <img :draggable="false"
      class="content-bg pc"
      :src="activityImages.web.video"
      alt=""
    />
    <img
      :draggable="false"
      class="content-bg mobile"
      :src="activityImages.mobile.video"
    />
    <div class="video-container">
      <div :draggable="false" class="content-vedio-instance" id="player"></div>
    </div>
    <img :draggable="false"
      class="content-vedio pc"
       :src=" current === 0 ?  activityImages.web.video1  :  activityImages.web.video2 "
    />
    <img
      :draggable="false"
      class="content-vedio mobile"
      :src=" current === 0 ? activityImages.mobile.video1 : activityImages.mobile.video2 "
    />
    <img
      :draggable="false"
      class="content-vedio-control-r pc"
      @click="handleNext"
      :src="activityImages.web.btn_right"
    />
    <img
      :draggable="false"
      class="content-vedio-control-l pc"
      @click="handlePreview"
      :src="activityImages.web.btn_left"
    />
    <img
      :draggable="false"
      class="content-vedio-control-r mobile"
      @click="handleNext"
      :src="activityImages.mobile.btn_right"
    />
    <img
      :draggable="false"
      class="content-vedio-control-l mobile"
      @click="handlePreview"
      :src="activityImages.mobile.btn_left"
    />
  </header>
</template>

<script>
import insertPlayer from '@bilibili-firebird/kuma/insertPlayer';
import { onMounted, ref } from 'vue';
import activityImages from '../config/images';

export default {
  name: 'App',
  components: {},
  setup() {
    const aids = [933706841, 642814157];
    const current = ref(0);
    const play = async () => {
      document.getElementById('player').innerHTML = '';
      const player = await insertPlayer({
        aid: aids[current.value],
        selector: '#player',
      });
      if (!player) throw new Error('播放器加载失败啦！');
    };
    onMounted(async () => {
      play();
    });
    const handlePreview = () => {
      current.value = current.value === 0 ? aids.length - 1 : current.value - 1;
      play();
    };
    const handleNext = () => {
      current.value = current.value === aids.length - 1 ? 0 : current.value + 1;
      play();
    };
    return {
      current,
      activityImages,
      handlePreview,
      handleNext,
    };
  },
};
</script>

<style lang="less">
.vedio-content {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
}
.content-bg{
  width: 100%;
}

.content-vedio {
  position: absolute;
  width: 41%;
  top: 24%;
  left: 29.5%;
  z-index: 1;
}
 .video-container{
    position: absolute;
    width: 39.3%;
    height: 58%;
    border-radius: 10px;
    top: 26%;
    left: 30.4%;
    z-index: 99999;
    overflow: hidden;
 }

.content-vedio-instance {
  width: 100%;
  height: 100%;
}
.content-vedio-control-l {
  cursor: pointer;
  position: absolute;
  left: 22%;
  border-radius: 10px;
  top: 50%;
}
.content-vedio-control-r {
  cursor: pointer;
  position: absolute;
  right: 22%;
  border-radius: 10px;
  top: 50%;
}
.player-container .player-box .display {
  .load-layer>img{
    height:auto !important;
  }
  .state-icon,.load-layer>i{
    bottom: 17pt !important;
    opacity: 0.85 !important;
  }
}
@media screen and (max-width: 870px) {
  .vedio-content {
    max-width: 940px;
  }
  .content-vedio {
    position: absolute;
    width: 78%;
    top: 30%;
    left: 11%;
    z-index: 1;
  }
  .video-container{
    position: absolute;
    width: 74%;
    height: 54%;
    top: 32.1%;
    left: 13.2%;
    z-index: 99999;
  }
  .content-vedio-instance {
    width: 100%;
    height: 100%;
  }
  .content-vedio-control-l{
    width: 7.5%;
    max-width: 50px;
    left: 8px;
    top: 55%;
  }
  .content-vedio-control-r {
    width: 7.5%;
    max-width: 50px;
    right: 8px;
    top: 55%;
  }
}
</style>
